
import { defineComponent } from 'vue'
import { useI18n } from 'vue-i18n'

import BaseSvgIcon from '@/components/BaseSvgIcon.vue'
import { mdiLoading } from '@mdi/js'

export default defineComponent({
  components: { BaseSvgIcon },
  props: {
    disabled: {
      type: Boolean,
      'default': () => (false),
    },
    text: {
      type: String,
      'default': () => (useI18n().t('word.send')),
    },
    color: {
      type: String,
      'default': () => ('bg-blue-500 hover:bg-blue-400 text-white'),
    },
  },
  setup() {
    return {
      mdiLoading,
    }
  },
})
